import reducer from "./reducer";
export { default as OrgChart } from "./components/index";
export { default as orgChartReducerName } from "./constants";
export default reducer;
